import type { topics } from "@/mocks/topics";

type Topic = (typeof topics)[number];

interface ArticleBodyProps {
  topic: Topic;
}

export default function ArticleBody({ topic }: ArticleBodyProps) {
  return (
    <article className="min-w-0">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
        <img
          src={topic.cover}
          alt={`${topic.title} 专题配图`}
          title={`${topic.title} - 513吃瓜热梗整理`}
          className="h-56 w-full object-cover object-top md:h-80"
        />
      </div>

      <p className="mt-8 border-l-4 border-primary-500 bg-background-100 px-5 py-4 text-base leading-relaxed text-foreground-800 md:text-lg">
        {topic.intro}
      </p>

      <div className="prose-chigua mt-10 space-y-10">
        {topic.sections.map((section) => (
          <section key={section.id} id={section.id} className="scroll-mt-28">
            <h2 className="flex items-center gap-3 text-xl text-foreground-950 md:text-2xl">
              <span className="h-6 w-1.5 rounded-full bg-accent-500" aria-hidden="true"></span>
              {section.heading}
            </h2>
            <div className="mt-4 space-y-4">
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph.slice(0, 12)} className="text-sm leading-loose text-foreground-700 md:text-base">
                  {paragraph}
                </p>
              ))}
            </div>
          </section>
        ))}
      </div>

      <section className="mt-12 rounded-lg border border-secondary-200 bg-secondary-50 p-6" aria-labelledby="takeaway-title">
        <h2 id="takeaway-title" className="flex items-center gap-2 text-lg text-secondary-800 md:text-xl">
          <i className="ri-bookmark-3-line" aria-hidden="true"></i>
          划重点
        </h2>
        <ul className="mt-4 space-y-3">
          {topic.takeaways.map((item) => (
            <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-700">
              <span className="mt-1.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-secondary-500 text-[10px] text-background-50">
                <i className="ri-check-line" aria-hidden="true"></i>
              </span>
              {item}
            </li>
          ))}
        </ul>
      </section>
    </article>
  );
}